import { render, staticRenderFns } from "./vesselDetailTabs.vue?vue&type=template&id=104cf0aa&scoped=true"
import script from "./vesselDetailTabs.vue?vue&type=script&lang=js"
export * from "./vesselDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./vesselDetailTabs.vue?vue&type=style&index=0&id=104cf0aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104cf0aa",
  null
  
)

export default component.exports